
import {
  API_BASE_URL,
  BUSINESS_BOOKING_API_URL
} from '../globals';

import {
  GET_TASK_DATA,
  ADD_SOFTDATA,
  GET_UPDATED_TASK_DETAILS,
  PRINT_ADDRESS_LABEL
} from './routes';

import { GET, POST } from './apiHandler';

export const getTaskData = async (queryString1: string, queryString2: string) => {
  return await GET(`${API_BASE_URL}${GET_TASK_DATA}`, { number: queryString1, type: queryString2 });
};

export const addSoftData = async (body) => {
  return POST(
    `${API_BASE_URL}${ADD_SOFTDATA}`,
    body
  );
};

export const getUpdatedTaskDetails = async (params) => {
  const { 
    taskID, 
    pageSize = 50, 
    lastRowIdNext, 
    lastRowIdPrev, 
    nextOrPrev = 'next', 
    sortBy = 'id' 
  } = params;

  const body = {
    taskID,
    pageSize,
    sortBy
  };

  if (nextOrPrev === 'next' && lastRowIdNext) {
    body.lastRowIdNext = lastRowIdNext;
    body.nextOrPrev = 'next';
  } else if (nextOrPrev === 'prev' && lastRowIdPrev) {
    body.lastRowIdPrev = lastRowIdPrev;
    body.nextOrPrev = 'prev';
  }

  return await POST(`${API_BASE_URL}${GET_UPDATED_TASK_DETAILS}`,
    body
  );
};

export const printAddressLabel = async (body) => {
  return POST(
    `${BUSINESS_BOOKING_API_URL}${PRINT_ADDRESS_LABEL}`,
    body,
    null,
    true
  );
};
